/* ═══════════════════════════════════════════
   BOLDACC THEME — theme.js v2.3
   (v2.3: cart drawer — 1/2/3 bundle pricing, free gifts, add-ons)
   ═══════════════════════════════════════════ */

'use strict';

/* ── CONFIG (set from Liquid in theme.liquid) ── */
const Boldacc = window.BOLDACC || { prepaidDiscount: 10000, partialCodAdvance: 100 };

/* ── CART STATE ── */
let cartData = { items: [], item_count: 0, total_price: 0 };

/* ═══════════════════
   NAVIGATION
═══════════════════ */
function toggleNav(id) {
  const allItems = document.querySelectorAll('.nav-item');
  allItems.forEach(el => {
    if (el.dataset.nav !== id) {
      el.classList.remove('is-open');
      const trigger = el.querySelector('.nav-item__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
  });
  const item = document.querySelector('[data-nav="' + id + '"]');
  if (!item) return;
  const isOpen = item.classList.toggle('is-open');
  const trigger = item.querySelector('.nav-item__trigger');
  if (trigger) trigger.setAttribute('aria-expanded', isOpen.toString());
}

document.addEventListener('click', function(e) {
  if (!e.target.closest('.nav-item')) {
    document.querySelectorAll('.nav-item.is-open').forEach(el => {
      el.classList.remove('is-open');
      const trigger = el.querySelector('.nav-item__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }
});

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('.nav-item.is-open').forEach(el => el.classList.remove('is-open'));
    closeMobileNav();
    closeCart();
    const searchOverlay = document.getElementById('searchOverlay');
    if (searchOverlay) searchOverlay.classList.remove('is-open');
  }
});

/* ═══════════════════
   MOBILE NAV
═══════════════════ */
function openMobileNav() {
  const drawer = document.getElementById('mobileNavDrawer');
  const overlay = document.getElementById('mobileNavOverlay');
  const btn = document.getElementById('hamburgerBtn');
  if (drawer) drawer.classList.add('is-open');
  if (overlay) { overlay.style.display = 'block'; setTimeout(() => overlay.classList.add('is-open'), 20); }
  if (btn) { btn.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
  document.body.style.overflow = 'hidden';
}

function closeMobileNav() {
  const drawer = document.getElementById('mobileNavDrawer');
  const overlay = document.getElementById('mobileNavOverlay');
  const btn = document.getElementById('hamburgerBtn');
  if (drawer) drawer.classList.remove('is-open');
  if (overlay) { overlay.classList.remove('is-open'); setTimeout(() => { overlay.style.display = 'none'; }, 320); }
  if (btn) { btn.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
  document.body.style.overflow = '';
}

function toggleMobileAccordion(trigger) {
  const body = trigger.nextElementSibling;
  const isOpen = trigger.classList.toggle('is-open');
  if (body) body.classList.toggle('is-open', isOpen);
  trigger.setAttribute('aria-expanded', isOpen.toString());
}

/* ═══════════════════
   SWIPE CLOSE MOBILE NAV
═══════════════════ */
(function() {
  let startX = 0;
  document.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
  document.addEventListener('touchend', e => {
    const dx = e.changedTouches[0].clientX - startX;
    const drawer = document.getElementById('mobileNavDrawer');
    if (drawer && drawer.classList.contains('is-open') && dx < -60) closeMobileNav();
  }, { passive: true });
})();

/* ═══════════════════
   CART
═══════════════════ */
async function fetchCart() {
  try {
    const res = await fetch('/cart.js');
    if (!res.ok) return;
    cartData = await res.json();
    updateCartUI();
  } catch(e) {}
}

/* ── Cart drawer config: theme.liquid mein window.CART_DRAWER se aata hai ── */
const CD_BUNDLE_DEFAULT = { enabled: true, prices: { 1: 699, 2: 999, 3: 1299 }, extra: 433 };

const CartCfg = Object.assign({
  pickerCollection: 'prisma-collection-iphone',
  pickerCount: 4,
  partialCodAdvance: 99,
  autoAddGifts: true,
  gifts: {},
  addons: {}
}, window.CART_DRAWER || {});

CartCfg.bundle = Object.assign({}, CD_BUNDLE_DEFAULT, CartCfg.bundle || {});
CartCfg.bundle.prices = Object.assign({}, CD_BUNDLE_DEFAULT.prices, CartCfg.bundle.prices || {});

let cdAddonData = null;
let cdGiftData = null;
let cdPickerOpen = false;
let cdPickerProducts = null;
let cdSyncing = false;
let cdWarned = false;

/* Gift retry configuration */
const CD_BLOCK_KEY = 'cdGiftBlocked';

const cdGiftBlocked = {};

function cdBlockGift(handle, why) {
  cdGiftBlocked[handle] = true;
  if (window.console) {
    console.warn('[cart drawer] free gift "' + handle + '" skipped: ' + why);
  }
}
/* ── Helpers ── */
function cdEsc(s) {
  return String(s == null ? '' : s).replace(/[&<>"']/g, c => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
  ));
}

/* paise -> "₹1,299" */
function cdMoney(paise) {
  return '₹' + (Math.max(0, paise) / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
}

/* rupees -> "₹1,299" */
function cdRs(rupees) { return cdMoney(rupees * 100); }

function cdImg(url, w) {
  if (!url) return '';
  return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
}

function cdOrd(n) { return n === 1 ? '1st' : n === 2 ? '2nd' : n === 3 ? '3rd' : n + 'th'; }

function cdReadJSON(id) {
  try {
    const el = document.getElementById(id);
    if (el) return JSON.parse(el.textContent) || [];
  } catch(e) {}
  return [];
}

function cdAddons() { if (!cdAddonData) cdAddonData = cdReadJSON('cartAddonData'); return cdAddonData; }
function cdGifts()  { if (!cdGiftData)  cdGiftData  = cdReadJSON('cartGiftData');  return cdGiftData; }
function cdAddonHandles() { return cdAddons().map(a => a.handle); }
function cdGiftHandles()  { return cdGifts().map(g => g.handle); }

function cdIsGift(i)  { return cdGiftHandles().indexOf(i.handle) > -1; }
function cdIsAddon(i) { return cdAddonHandles().indexOf(i.handle) > -1; }

/* "Case" = cart ki wo lines jo na gift hain na add-on */
function cdCaseItems()  { return cartData.items.filter(i => !cdIsGift(i) && !cdIsAddon(i)); }
function cdGiftItems()  { return cartData.items.filter(cdIsGift); }
function cdAddonItems() { return cartData.items.filter(cdIsAddon); }

function cdCaseQty() {
  return cdCaseItems().reduce((n, i) => n + i.quantity, 0);
}

function cdCaseValues() {
  const c = cdCaseItems()[0];
  return ((c && c.options_with_values) || [])
    .map(o => String(o.value))
    .filter(v => v !== 'Default Title');
}

function cdModel() { return cdCaseValues()[0] || ''; }

/* Header cart badge: free gifts count nahi hote */
function cdVisibleCount() {
  const gifts = cdGiftItems().reduce((n, i) => n + i.quantity, 0);
  return Math.max(0, (cartData.item_count || 0) - gifts);
}
/* ── Bundle pricing (₹) — Shopify ke bundle discount se match hona chahiye ── */
function cdBundlePrice(n) {
  const b = CartCfg.bundle;
  if (n <= 0) return 0;
  if (n <= 3) return b.prices[n];
  return b.prices[3] + (n - 3) * b.extra;
}

/* ── Totals (sab paise mein, Shopify ke real cart data se) ── */
function cdTotals() {
  const sum = (arr, k) => arr.reduce((a, i) => a + i[k], 0);
  const cases = cdCaseItems(), gifts = cdGiftItems(), addons = cdAddonItems();
  const n = cases.reduce((a, i) => a + i.quantity, 0);
  const full = sum(cases, 'original_line_price');
  const net = sum(cases, 'final_line_price');

  const t = {
    n: n,
    full: full,
    net: net,
    saving: Math.max(0, full - net),
    addons: sum(addons, 'final_line_price'),
    gifts: sum(gifts, 'final_line_price'),
    total: cartData.total_price || 0
  };

  /* 2+ cases hain to Shopify ne bundle price sach mein lagaya hona chahiye (±₹1) */
  t.bundleOk = !CartCfg.bundle.enabled || n < 2 || Math.abs(net - cdBundlePrice(n) * 100) <= 100;

  if (!t.bundleOk && !cdWarned && window.console) {
    cdWarned = true;
    console.warn('[cart drawer] ' + n + ' cases ka bundle discount Shopify mein apply nahi hua. Expected ' +
      cdRs(cdBundlePrice(n)) + ', cart mein ' + cdMoney(net) + '. Discount (functions/bundle-discount) check karo.');
  }

  return t;
}

/* ── Cart requests (drawer ke andar) ── */
async function cdRequest(url, payload, errMsg) {
  const drawer = document.getElementById('cartDrawer');
  if (drawer) drawer.classList.add('is-busy');

  let ok = false;

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    ok = res.ok;

    if (!ok) {
      const err = await res.json().catch(() => ({}));
      showToast(err.description || errMsg || 'Could not update cart. Please try again.', true);
    }
  } catch(e) {
    showToast(errMsg || 'Could not update cart. Please try again.', true);
  }

  await fetchCart();

  if (drawer) drawer.classList.remove('is-busy');
  if (document.querySelector('.cart-page')) window.location.reload();

  return ok;
}

function cdChange(key, qty) {
  return cdRequest('/cart/change.js', { id: key, quantity: Math.max(0, qty) });
}

/* chup-chaap POST (toast / reload ke bina) — gift sync ke liye */
async function cdPost(url, payload) {
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    return res.ok;
  } catch(e) {
    return false;
  }
}

/* ── Line item ── */
function cdItemHTML(item, isAddon) {
  const key = cdEsc(item.key);
  const fin = item.final_line_price;
  const each = Math.round(fin / item.quantity);

  const variantTxt = (item.variant_title && item.variant_title !== 'Default Title')
    ? String(item.variant_title).split(' / ').join(' · ') : '';

  const variant = variantTxt ? '<div class="cd-item__variant">' + cdEsc(variantTxt) + '</div>' : '';

  const links = isAddon
    ? '<button type="button" class="cd-link" onclick="cdChange(\'' + key + '\', 0)">Remove</button>'
    : '<a href="' + cdEsc(item.url) + '">Change design or model</a> for any case · ' +
      '<button type="button" class="cd-link" onclick="cdChange(\'' + key + '\', 0)">Remove</button>';

  return '<div class="cd-item" data-key="' + key + '">' +
    '<a class="cd-item__thumb" href="' + cdEsc(item.url) + '">' +
      (item.image ? '<img src="' + cdEsc(cdImg(item.image, 160)) + '" alt="' + cdEsc(item.product_title) + '" width="76" height="76" loading="lazy">' : '') +
    '</a>' +
    '<div class="cd-item__body">' +
      '<div class="cd-item__name"><a href="' + cdEsc(item.url) + '">' + cdEsc(item.product_title) + '</a></div>' +
      variant +
      '<div class="cd-item__ctrl">' +
        '<div class="cd-qty">' +
          '<button type="button" class="cd-qty__b" onclick="cdChange(\'' + key + '\', ' + (item.quantity - 1) + ')" aria-label="Remove one"' + (item.quantity <= 1 ? ' disabled' : '') + '>−</button>' +
          '<div class="cd-qty__n">' + item.quantity + '</div>' +
          '<button type="button" class="cd-qty__b" onclick="cdChange(\'' + key + '\', ' + (item.quantity + 1) + ')" aria-label="Add one">+</button>' +
        '</div>' +
        '<div class="cd-item__price">' +
          '<div class="cd-item__total">' + cdMoney(fin) + '</div>' +
          '<div class="cd-item__each">' + cdMoney(each) + ' each</div>' +
        '</div>' +
      '</div>' +
      '<div class="cd-item__links">' + links + '</div>' +
    '</div>' +
  '</div>';
}
/* ── Bundle strip: "Add 1 more case for ₹300" ── */
function cdBundleState(n, t) {
  const b = CartCfg.bundle;
  const p = k => cdBundlePrice(k);
  const unit = t.full / n / 100;
  const step = p(n + 1) - p(n);
  const saved = n * unit - p(n);

  if (n === 1) return {
    title: 'Add 1 more case for ' + cdRs(step),
    count: '1 of 2',
    body: 'Any design, any phone model. Pay ' + cdRs(p(2)) + ' for both instead of ' + cdRs(2 * unit) + '.',
    pct: 50,
    pick: 'Pick your 2nd case',
    step: step
  };

  if (n === 2) return {
    title: '2 for ' + cdRs(p(2)) + ' unlocked',
    count: '2 of 3',
    body: 'Add a 3rd case for ' + cdRs(step) + ' more and pay ' + cdRs(p(3)) + ' for all three (' + cdRs(Math.round(p(3) / 3)) + ' each).',
    pct: 67,
    pick: 'Add a 3rd case for ' + cdRs(step),
    step: step
  };

  if (n === 3) return {
    title: 'Best value unlocked: 3 for ' + cdRs(p(3)),
    count: '3 of 3',
    body: 'You are saving ' + cdRs(saved) + ' on this order. Every extra case is ' + cdRs(b.extra) + '.',
    pct: 100,
    pick: '',
    step: step
  };

  return {
    title: 'Best value: ' + cdRs(b.extra) + ' per extra case',
    count: n + ' cases',
    body: 'You are saving ' + cdRs(saved) + ' on this order.',
    pct: 100,
    pick: '',
    step: step
  };
}

/* Picker: cart ke case jaisa hi model/variant wale bestseller designs */
function cdPickerVariant(p) {
  const c = cdCaseItems()[0];
  if (!c) return null;

  const title = String(c.variant_title || '').toLowerCase();
  const model = cdModel().toLowerCase();
  const avail = (p.variants || []).filter(v => v.available);

  let v = avail.find(x => String(x.title).toLowerCase() === title);

  if (!v && model) {
    v = avail.find(x =>
      [x.option1, x.option2, x.option3].some(o =>
        o && String(o).toLowerCase() === model
      )
    );
  }

  return v || null;
}

function cdPickerList() {
  const inCart = cartData.items.map(i => i.handle);
  const out = [];

  for (let i = 0; i < cdPickerProducts.length; i++) {
    const p = cdPickerProducts[i];
    if (inCart.indexOf(p.handle) > -1) continue;

    const v = cdPickerVariant(p);
    if (!v) continue;

    out.push({ p: p, v: v });
    if (out.length >= CartCfg.pickerCount) break;
  }

  return out;
}

function cdPickerGridHTML(step) {
  if (cdPickerProducts === null) {
    return '<div class="cd-picker__msg">Loading designs…</div>';
  }

  const list = cdPickerList();

  if (!list.length) {
    return '<div class="cd-picker__msg">No matching designs right now. Tap “See all designs” below.</div>';
  }

  return '<div class="cd-picker__grid">' + list.map(x => {
    const src = x.p.images && x.p.images[0] && x.p.images[0].src;
    const name = String(x.p.title).split(' - ')[0];

    return '<button type="button" class="cd-pk" data-vid="' + x.v.id + '" onclick="cdAddCase(this)">' +
      '<div class="cd-pk__im">' + (src ? '<img src="' + cdEsc(cdImg(src, 200)) + '" alt="" loading="lazy">' : '') + '</div>' +
      '<div class="cd-pk__nm">' + cdEsc(name) + '</div>' +
      '<div class="cd-pk__pr">+' + cdRs(step) + '</div>' +
    '</button>';
  }).join('') + '</div>';
}

function cdRenderStrip() {
  const wrap = document.getElementById('cdStrip');
  if (!wrap) return;

  const n = cdCaseQty();

  if (!CartCfg.bundle.enabled || !n) {
    wrap.hidden = true;
    wrap.innerHTML = '';
    return;
  }

  const t = cdTotals();

  if (n >= 2 && !t.bundleOk) {
    wrap.hidden = true;
    wrap.innerHTML = '';
    return;
  }

  const s = cdBundleState(n, t);
  const model = cdModel();
  let picker = '';

  if (s.pick && cdPickerOpen) {
    picker = '<div class="cd-picker">' +
      '<div class="cd-picker__hint">' +
        (model ? 'Bestsellers for ' + cdEsc(model) + '. ' : 'Bestsellers. ') +
        'Tap one to add it.</div>' +
      cdPickerGridHTML(s.step) +
      '<a class="cd-picker__more" href="/collections/' + cdEsc(CartCfg.pickerCollection) + '">See all designs</a>' +
    '</div>';
  }

  wrap.hidden = false;
  wrap.innerHTML =
    '<section class="cd-strip">' +
      '<div class="cd-strip__row">' +
        '<div class="cd-strip__title">' + cdEsc(s.title) + '</div>' +
        '<div class="cd-strip__count">' + cdEsc(s.count) + '</div>' +
      '</div>' +
      '<div class="cd-strip__body">' + cdEsc(s.body) + '</div>' +
      '<div class="cd-strip__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + s.pct + '">' +
        '<i style="width:' + s.pct + '%"></i>' +
      '</div>' +
      (s.pick ? '<button type="button" class="cd-strip__pick" onclick="cdTogglePicker()" aria-expanded="' + (cdPickerOpen ? 'true' : 'false') + '">' + cdEsc(s.pick) + '</button>' : '') +
      picker +
    '</section>';
}

async function cdLoadPicker() {
  try {
    const res = await fetch('/collections/' + encodeURIComponent(CartCfg.pickerCollection) + '/products.json?limit=24&sort_by=best-selling');
    const data = await res.json();
    cdPickerProducts = data.products || [];
  } catch(e) {
    cdPickerProducts = [];
  }

  cdRenderStrip();
}

function cdTogglePicker() {
  cdPickerOpen = !cdPickerOpen;
  cdRenderStrip();

  if (cdPickerOpen && cdPickerProducts === null) cdLoadPicker();
}

/* Picker se case add — normal price par jaata hai, bundle discount Shopify lagata hai */
async function cdAddCase(btn) {
  const vid = parseInt(btn.dataset.vid, 10);
  if (!vid) return;

  cdPickerOpen = false;

  const ok = await cdRequest('/cart/add.js', { items: [{ id: vid, quantity: 1 }] });

  if (ok && CartCfg.bundle.enabled && cdCaseQty() >= 2 && !cdTotals().bundleOk) {
    showToast('Bundle price could not be applied. Please check your cart.', true);
  }
}

/* ── Free gifts ── */
function cdGiftVariant(g) {
  return (g.variants || []).find(v => v.available) || (g.variants || [])[0] || null;
}

function cdGiftWorth(g) {
  const v = cdGiftVariant(g);
  return v ? Math.max(v.compare || 0, v.price || 0) : 0;
}

/* FIX: case cart mein hai to configured gifts ko block list ke karan hide mat karo */
function cdGiftList() {
  if (!cdCaseQty()) return [];
  return cdGifts();
}


function cdRenderGifts() {
  const wrap = document.getElementById('cdGifts');
  if (!wrap) return;

  const list = cdGiftList();

  if (!list.length) {
    wrap.hidden = true;
    wrap.innerHTML = '';
    return;
  }

  const worth = list.reduce((total, gift) => total + cdGiftWorth(gift), 0);

  const rows = list.map(gift => {
    const cfg = CartCfg.gifts[gift.handle] || {};
    const giftWorth = cdGiftWorth(gift);

    return '<div class="cd-gift">' +
      '<div class="cd-gi">' +
        (gift.image
          ? '<img src="' + cdEsc(cdImg(gift.image, 120)) + '" alt="' + cdEsc(cfg.name || gift.title) + '" loading="lazy">'
          : '') +
      '</div>' +
      '<div class="cd-gift__txt">' +
        '<strong>' + cdEsc(cfg.name || gift.title) + '</strong>' +
        (cfg.desc ? '<span>' + cdEsc(cfg.desc) + '</span>' : '') +
      '</div>' +
      '<div class="cd-gift__right">' +
        (giftWorth > 0 ? '<s>' + cdMoney(giftWorth) + '</s>' : '') +
        '<span class="cd-free">FREE</span>' +
      '</div>' +
    '</div>';
  }).join('');

  wrap.hidden = false;

  wrap.innerHTML =
    '<div class="cd-gifts__head">' +
      '<div class="cd-gifts__title">Free with your order</div>' +
      '<div class="cd-gifts__meta">1 set per order · worth ' + cdMoney(worth) + '</div>' +
    '</div>' +
    rows +
    '<div class="cd-warranty">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6E5520" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z"></path>' +
        '<path d="M9 12l2 2 4-4"></path>' +
      '</svg>' +
      '<span><strong>Lifetime print warranty</strong> on every case in this cart</span>' +
    '</div>';
}


/* Cart ko gifts ke saath sync rakho:
   - Case cart mein ho to har gift ek baar add ho
   - Case nahi ho to gifts remove ho
   - Gift free na ho to paid item cart mein na rahe
*/

async function cdSyncGifts() {
  if (cdSyncing || !CartCfg.autoAddGifts) return;

  const gifts = cdGifts();
  if (!gifts.length) return;

  cdSyncing = true;
  let changed = false;

  try {
    const cartRes = await fetch('/cart.js');
    if (cartRes.ok) {
      cartData = await cartRes.json();
    }

    const caseQty = cdCaseQty();
    const lines = cdGiftItems();
    const updates = {};
    const seen = {};

    if (caseQty === 0) {
      lines.forEach(line => {
        updates[line.key] = 0;
      });
    } else {
      lines.forEach(line => {
        if (line.final_line_price > 0) {
          updates[line.key] = 0;
          cdBlockGift(
            line.handle,
            'Gift free nahi hai; paid item remove kiya'
          );
        } else if (seen[line.handle]) {
          updates[line.key] = 0;
        } else {
          seen[line.handle] = true;

          if (line.quantity !== 1) {
            updates[line.key] = 1;
          }
        }
      });
    }

    if (Object.keys(updates).length) {
      const updated = await cdPost('/cart/update.js', {
        updates: updates
      });

      if (updated) changed = true;

      const refreshRes = await fetch('/cart.js');
      if (refreshRes.ok) {
        cartData = await refreshRes.json();
      }
    }

    if (cdCaseQty() > 0) {
      for (let i = 0; i < gifts.length; i++) {
        const gift = gifts[i];

        if (seen[gift.handle] || cdGiftBlocked[gift.handle]) {
          continue;
        }

        const variant = cdGiftVariant(gift);

        if (!variant || !variant.available) {
          cdBlockGift(gift.handle, 'Gift variant available nahi hai');
          continue;
        }

        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: variant.id,
              quantity: 1
            }]
          })
        });

        if (!addRes.ok) {
          const error = await addRes.json().catch(() => ({}));

          if (window.console) {
            console.warn(
              '[cart drawer] Gift add nahi hua:',
              gift.handle,
              error.description || ''
            );
          }

          continue;
        }

        changed = true;

        const refreshRes = await fetch('/cart.js');

        if (refreshRes.ok) {
          cartData = await refreshRes.json();
        }

        const addedLines = cdGiftItems().filter(
          line => line.handle === gift.handle
        );

        const paidLines = addedLines.filter(
          line => line.final_line_price > 0
        );

        if (paidLines.length) {
          const removeUpdates = {};

          paidLines.forEach(line => {
            removeUpdates[line.key] = 0;
          });

          await cdPost('/cart/update.js', {
            updates: removeUpdates
          });

          cdBlockGift(
            gift.handle,
            'Gift discount apply nahi hua; paid item remove kiya'
          );

          const finalRes = await fetch('/cart.js');

          if (finalRes.ok) {
            cartData = await finalRes.json();
          }
        } else {
          seen[gift.handle] = true;
        }
      }
    }
  } catch (error) {
    if (window.console) {
      console.warn('[cart drawer] Gift sync error:', error);
    }
  } finally {
    cdSyncing = false;
  }

  if (changed) {
    await fetchCart();
  } else {
    cdRenderGifts();
    cdUpdateFooter();
  }
}


/* ── Add-ons (Goes with your case) ── */

/* Add-on ka variant cart ke phone model se match karo */
function cdResolve(a) {
  const caseVals = cdCaseValues().map(v => v.toLowerCase());
  let exact = true;

  const want = a.options.map(o => {
    if (o.values.length === 1) return o.values[0];

    const match = o.values.find(
      v => caseVals.indexOf(String(v).toLowerCase()) > -1
    );

    if (match) return match;

    exact = false;
    return o.values[0];
  });

  let variant = a.variants.find(
    x => want.every((w, i) => x.options[i] === w)
  );

  if (!variant) {
    exact = false;
    variant = a.variants.find(x => x.available) || a.variants[0];
  }

  return {
    variant: variant,
    exact: exact
  };
}


function cdAddonHTML(a) {
  const cfg = CartCfg.addons[a.handle] || {};
  const line = cartData.items.find(item => item.handle === a.handle);
  const result = cdResolve(a);
  const variant = result.variant;

  if (!variant) return '';

  const desc = String(cfg.desc || '').replace(
    '{model}',
    cdModel() || 'your phone'
  );

  const handle = cdEsc(a.handle);

  const price = variant.compare > variant.price
    ? '<s>' + cdMoney(variant.compare) + '</s><strong>' + cdMoney(variant.price) + '</strong>'
    : '<strong>' + cdMoney(variant.price) + '</strong>';

  let button;

  if (line) {
    button = '<button type="button" class="cd-addon__add" onclick="cdToggleAddon(\'' + handle + '\')">Added</button>';
  } else if (!variant.available) {
    button = '<button type="button" class="cd-addon__add" disabled>Sold out</button>';
  } else {
    button = '<button type="button" class="cd-addon__add" onclick="cdToggleAddon(\'' + handle + '\')">Add</button>';
  }

  return '<div class="cd-addon' + (line ? ' is-added' : '') + '">' +
    '<div class="cd-addon__im">' +
      '<div class="cd-gi">' +
        (a.image
          ? '<img src="' + cdEsc(cdImg(a.image, 120)) + '" alt="' + cdEsc(cfg.name || a.title) + '" loading="lazy">'
          : '') +
      '</div>' +
    '</div>' +
    '<div class="cd-addon__txt">' +
      '<strong>' + cdEsc(cfg.name || a.title) + '</strong>' +
      (desc ? '<span>' + cdEsc(desc) + '</span>' : '') +
    '</div>' +
    '<div class="cd-addon__right">' +
      '<div class="cd-addon__price">' + price + '</div>' +
      button +
    '</div>' +
  '</div>';
}


function cdRenderAddons() {
  const wrap = document.getElementById('cdAddons');
  if (!wrap) return;

  if (!cdCaseQty()) {
    wrap.hidden = true;
    wrap.innerHTML = '';
    return;
  }

  const addons = cdAddons();

  if (!addons.length) {
    wrap.hidden = true;
    wrap.innerHTML = '';
    return;
  }

  const html = addons.map(cdAddonHTML).join('');

  if (!html) {
    wrap.hidden = true;
    wrap.innerHTML = '';
    return;
  }

  wrap.hidden = false;

  wrap.innerHTML =
    '<div class="cd-addons__head">' +
      '<div class="cd-addons__title">Goes with your case</div>' +
    '</div>' +
    html;
}



async function cdToggleAddon(handle) {
  const addon = cdAddons().find(
    item => item.handle === handle
  );

  if (!addon) return;

  const line = cartData.items.find(
    item => item.handle === handle
  );

  if (line) {
    await cdChange(line.key, 0);
    return;
  }

  const result = cdResolve(addon);
  const variant = result.variant;

  if (!variant || !variant.available) {
    showToast('This add-on is currently unavailable.', true);
    return;
  }

  await cdRequest('/cart/add.js', {
    items: [{
      id: variant.id,
      quantity: 1
    }]
  });
}
/* ── Footer totals ── */

function cdUpdateFooter() {
  const t = cdTotals();

  const setText = (id, txt) => {
    const el = document.getElementById(id);
    if (el) el.textContent = txt;
  };

  const show = (id, on) => {
    const el = document.getElementById(id);
    if (el) el.hidden = !on;
  };

  const cases = cdCaseItems();

  const same = cases.length > 0 &&
    cases.every(i => i.original_price === cases[0].original_price);

  setText(
    'cdLineLabel',
    t.n + ' case' + (t.n === 1 ? '' : 's') +
    (same ? ' at ' + cdMoney(cases[0].original_price) : '')
  );

  setText('cdLineFull', cdMoney(t.full));
  setText('cdSaving', '- ' + cdMoney(t.saving));

  const hasAddons = cdAddonItems().length > 0;

  show('cdAddonRow', hasAddons);
  setText('cdAddonAmt', cdMoney(t.addons));

  const giftList = cdGiftList();

  show('cdGiftRow', giftList.length > 0);

  setText(
    'cdGiftLabel',
    'Free gifts (worth ' +
      cdMoney(
        giftList.reduce((total, gift) => {
          return total + cdGiftWorth(gift);
        }, 0)
      ) +
    ')'
  );

  setText('cdGiftAmt', cdMoney(t.gifts));
  setText('cartSubtotal', cdMoney(t.total));
  setText('cdCtaAmt', cdMoney(t.total));

  const prepaid = document.getElementById('cdPrepaid');

  if (prepaid) {
    const discount = Boldacc.prepaidDiscount || 0;
    const advance = CartCfg.partialCodAdvance || 0;

    let message = '';

    if (discount > 0) {
      message +=
        'Pay online and pay ' +
        cdMoney(t.total - discount) +
        ' (' + cdMoney(discount) + ' off).';
    }

    if (advance > 0 && t.total > advance * 100) {
      message +=
        (message ? ' ' : '') +
        'Or pay ₹' + advance + ' now, rest on delivery.';
    }

    prepaid.textContent = message;
    prepaid.hidden = !message;
  }
}


/* ── Main cart render ── */

function updateCartUI() {
  const count = cdVisibleCount();

  const countEl = document.getElementById('cartCount');

  if (countEl) {
    countEl.textContent = count;
    countEl.style.display = count > 0 ? 'flex' : 'none';
  }

  const cartItems = document.getElementById('cartItems');
  const cartEmpty = document.getElementById('cartEmpty');
  const cartFooter = document.getElementById('cartFooter');
  const content = document.getElementById('cdContent');

  if (!cartItems) return;

  if (count === 0) {
    if (cartEmpty) cartEmpty.style.display = 'flex';
    if (content) content.hidden = true;
    if (cartFooter) cartFooter.style.display = 'none';

    cartItems.innerHTML = '';

    cdRenderGifts();
    cdSyncGifts();

    return;
  }

  if (cartEmpty) cartEmpty.style.display = 'none';
  if (content) content.hidden = false;
  if (cartFooter) cartFooter.style.display = 'flex';

  cartItems.innerHTML =
    cdCaseItems().map(item => cdItemHTML(item, false)).join('') +
    cdAddonItems().map(item => cdItemHTML(item, true)).join('');

  cdRenderStrip();
  cdRenderGifts();
  cdRenderAddons();
  cdUpdateFooter();
  cdSyncGifts();
}


/* ── Main Add to Cart ── */

async function addToCart(variantId, quantity, properties) {
  try {
    const body = {
      items: [{
        id: variantId,
        quantity: quantity || 1,
        properties: properties || {}
      }]
    };

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));

      showToast(
        error.description ||
          'Could not add to cart. Please try again.',
        true
      );

      return;
    }

    await fetchCart();
    openCart();
    showToast('Added to cart!');

  } catch (error) {
    showToast(
      'Error adding to cart. Please try again.',
      true
    );
  }
}


/* ── Update cart item quantity ── */

async function updateCartItem(variantId, quantity) {
  try {
    const updates = {};
    updates[variantId] = quantity;

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates: updates
      })
    });

    await fetchCart();

    if (document.querySelector('.cart-page')) {
      window.location.reload();
    }

  } catch (error) {}
}


/* ── Open cart drawer ── */

function openCart() {
  const drawer = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartOverlay');

  if (drawer) {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
  }

  if (overlay) {
    overlay.style.display = 'block';

    setTimeout(() => {
      overlay.classList.add('is-open');
    }, 20);
  }

  document.body.style.overflow = 'hidden';

  fetchCart();

  setTimeout(() => {
    const closeBtn =
      drawer && drawer.querySelector('.cd-close');

    if (closeBtn) closeBtn.focus();
  }, 60);
}


/* ── Close cart drawer ── */

function closeCart() {
  const drawer = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartOverlay');

  if (drawer) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  if (overlay) {
    overlay.classList.remove('is-open');

    setTimeout(() => {
      overlay.style.display = 'none';
    }, 320);
  }

  document.body.style.overflow = '';
  cdPickerOpen = false;
}


/* ── Quick add ── */

function quickAddToCart(event, variantId) {
  event.preventDefault();
  event.stopPropagation();

  addToCart(variantId, 1);
}
/* ═══════════════════
   PRODUCT PAGE
═══════════════════ */

function setMainImage(thumb) {
  const mainImg = document.getElementById('mainImage');

  if (mainImg && thumb.dataset.src) {
    mainImg.src = thumb.dataset.src;
  }

  document.querySelectorAll('.product-gallery__thumb').forEach(t => {
    t.classList.remove('is-active');
  });

  thumb.classList.add('is-active');
}


// Option selectors

let selectedOptions = {};


function selectOption(btn, position) {
  const container = btn.closest('.option-pills, .color-swatches');

  if (!container) return;

  container.querySelectorAll('.option-pill, .color-swatch').forEach(el => {
    el.classList.remove('is-active');
  });

  btn.classList.add('is-active');

  const selectedLabel = document.getElementById(
    'opt-selected-' + position
  );

  if (selectedLabel) {
    selectedLabel.textContent = btn.dataset.value;
  }

  selectedOptions[position] = btn.dataset.value;

  updateVariantFromOptions();
}


function selectOptionFromDropdown(select, position) {
  const value = select.value;

  const selectedLabel = document.getElementById(
    'opt-selected-' + position
  );

  if (selectedLabel) {
    selectedLabel.textContent = value;
  }

  selectedOptions[position] = value;

  updateVariantFromOptions();
}


function updateVariantFromOptions() {
  if (!window.productVariants || !window.productVariants.length) {
    return;
  }

  const optionValues = [];

  Object.keys(selectedOptions)
    .sort((a, b) => a - b)
    .forEach(pos => {
      optionValues.push(selectedOptions[pos]);
    });

  const matchingVariant = window.productVariants.find(variant =>
    optionValues.every((value, index) => {
      return variant.options[index] === value;
    })
  );

  if (!matchingVariant) return;

  const variantInput = document.getElementById('variantId');

  if (variantInput) {
    variantInput.value = matchingVariant.id;
  }

  // Update URL without reload

  if (window.history && window.history.replaceState) {
    const url = new URL(window.location.href);

    url.searchParams.set('variant', matchingVariant.id);

    window.history.replaceState({}, '', url.toString());
  }

  // Update price display

  updatePaymentPrices(
    matchingVariant.price,
    matchingVariant.compare_at_price
  );

  updateAddToCartButton(matchingVariant);

  // Update main image if variant has one

  if (matchingVariant.featured_image) {
    const mainImg = document.getElementById('mainImage');

    if (mainImg) {
      mainImg.src = matchingVariant.featured_image.src;
    }
  }

  const addBtn = document.getElementById('addToCartBtn');
  const btnText = document.getElementById('addToCartText');
  const buyNowWrap = document.querySelector('.product-buynow-wrap');

  if (addBtn) {
    addBtn.disabled = !matchingVariant.available;

    if (!matchingVariant.available && btnText) {
      btnText.textContent = 'Sold Out';
    }
  }

  if (buyNowWrap) {
    buyNowWrap.style.display = matchingVariant.available
      ? 'block'
      : 'none';
  }
}


function updatePaymentPrices(price, comparePrice) {
  const fmt = value => {
    return '₹' + (Math.max(0, value) / 100).toLocaleString('en-IN');
  };

  const discount = Boldacc.prepaidDiscount;

  const prepaidFinal = document.getElementById('prepaidFinalPrice');
  const prepaidOriginal = document.getElementById('prepaidOriginalPrice');

  if (prepaidFinal) {
    prepaidFinal.textContent = fmt(price - discount);
  }

  if (prepaidOriginal) {
    prepaidOriginal.textContent = fmt(price);
  }

  const partialFinal = document.getElementById('partialFinalPrice');

  if (partialFinal) {
    partialFinal.textContent = fmt(price);
  }

  const codFinal = document.getElementById('codFinalPrice');

  if (codFinal) {
    codFinal.textContent = fmt(price);
  }

  /* Update Main Product Price on variant change */

  const mainPriceWrap = document.querySelector('.product-main-price');

  if (mainPriceWrap) {
    const priceCurrent = mainPriceWrap.querySelector('.price-current');
    const priceOriginal = mainPriceWrap.querySelector('.price-original');
    const discountBadge = mainPriceWrap.querySelector('.price-discount-badge');

    if (priceCurrent) {
      priceCurrent.textContent = fmt(price);
    }

    if (comparePrice && comparePrice > price) {
      if (priceOriginal) {
        priceOriginal.textContent = fmt(comparePrice);
        priceOriginal.style.display = '';
      }

      if (discountBadge) {
        discountBadge.textContent =
          '-' + Math.round(
            (comparePrice - price) * 100 / comparePrice
          ) + '%';

        discountBadge.style.display = '';
      }
    } else {
      if (priceOriginal) {
        priceOriginal.style.display = 'none';
      }

      if (discountBadge) {
        discountBadge.style.display = 'none';
      }
    }
  }
}


function updateAddToCartButton(variant) {
  const btn = document.getElementById('addToCartBtn');
  const btnText = document.getElementById('addToCartText');

  if (!btn || !btnText || !variant) return;

  if (!variant.available) {
    btnText.textContent = 'Sold Out';
    return;
  }

  btnText.textContent = 'Add to Cart';
}


function updateBuyNowUrl(variantId) {
  const buyNowBtn = document.getElementById('buyNowBtn');

  if (buyNowBtn) {
    buyNowBtn.href = '/checkout?variant=' + variantId + '&quantity=1';
  }
}


// Quantity

function changeQty(delta) {
  const input = document.getElementById('productQty');

  if (!input) return;

  input.value = Math.max(
    1,
    (parseInt(input.value) || 1) + delta
  );
}


// Accordion

function toggleAccordion(trigger) {
  const body = trigger.nextElementSibling;
  const isOpen = trigger.classList.toggle('is-open');

  if (body) {
    body.classList.toggle('is-open', isOpen);
  }
}
/* ═══════════════════
   PRODUCT FORM SUBMIT
═══════════════════ */

document.addEventListener('DOMContentLoaded', function() {

  // Load product variants JSON
  const productJsonScripts = document.querySelectorAll(
    'script[id^="ProductJSON-"]'
  );

  productJsonScripts.forEach(function(script) {
    try {
      window.productVariants = JSON.parse(script.textContent);
    } catch(e) {}
  });

  // Initialize selected options from active pills/swatches
  document.querySelectorAll(
    '.option-pills .option-pill.is-active, .color-swatches .color-swatch.is-active'
  ).forEach(el => {
    const container = el.closest('[data-option-position]');

    if (container) {
      selectedOptions[
        parseInt(container.dataset.optionPosition)
      ] = el.dataset.value;
    }
  });

  // Initialize selected model dropdowns
  document.querySelectorAll('.model-select').forEach(select => {
    const container = select.closest('[data-option-position]');

    if (!container) return;

    const position = container.dataset.optionPosition;
    selectedOptions[position] = select.value;
  });

  // Initialize Add to Cart button
  if (window.productVariants && window.productVariants.length) {
    const variantInput = document.getElementById('variantId');
    const initId = variantInput
      ? parseInt(variantInput.value, 10)
      : null;

    const initVariant = initId
      ? window.productVariants.find(v => v.id === initId)
      : window.productVariants.find(v => v.available) ||
        window.productVariants[0];

    if (initVariant) {
      updateAddToCartButton(initVariant);
    }
  }

  // Product form submit → AJAX Add to Cart
  const productForm = document.getElementById('ProductForm');

  if (productForm) {
    productForm.addEventListener('submit', async function(e) {
      e.preventDefault();

      const variantInput = document.getElementById('variantId');

      if (!variantInput || !variantInput.value) {
        showToast('Please select a product variant.', true);
        return;
      }

      const variantId = parseInt(variantInput.value, 10);
      const qty = parseInt(
        document.getElementById('productQty')?.value || 1,
        10
      );
      const paymentType =
        document.getElementById('paymentTypeInput')?.value || 'prepaid';

      const btn = document.getElementById('addToCartBtn');
      const btnText = document.getElementById('addToCartText');

      if (btn) {
        btn.disabled = true;

        if (btnText) {
          btnText.textContent = 'Adding...';
        }
      }

      try {
        await addToCart(variantId, qty, {
          'Payment Method': paymentType
        });
      } finally {
        if (btn) {
          btn.disabled = false;

          const variant = window.productVariants &&
            window.productVariants.find(v => v.id === variantId);

          if (variant) {
            updateAddToCartButton(variant);
          }
        }
      }
    });
  }

  // Scroll thumbnails on swipe (mobile)
  const thumbs = document.getElementById('galleryThumbs');

  if (thumbs) {
    let startX = 0;

    thumbs.addEventListener(
      'touchstart',
      e => {
        startX = e.touches[0].clientX;
      },
      { passive: true }
    );

    thumbs.addEventListener(
      'touchend',
      e => {
        const dx = e.changedTouches[0].clientX - startX;

        if (Math.abs(dx) > 40) {
          thumbs.scrollLeft -= dx;
        }
      },
      { passive: true }
    );
  }

  // Announcement bar animated close
  const annClose = document.querySelector('.announcement-bar__close');

  if (annClose) {
    annClose.addEventListener('click', () => {
      const bar = annClose.closest('.announcement-bar');

      if (!bar) return;

      bar.style.cssText +=
        ';height:' + bar.offsetHeight +
        'px;overflow:hidden;transition:height .3s,padding .3s';

      setTimeout(() => {
        bar.style.height = '0';
        bar.style.padding = '0';
      }, 10);

      setTimeout(() => {
        bar.style.display = 'none';
      }, 320);
    });
  }

  // Half-star visual rendering
  document.querySelectorAll('.star--half').forEach(function(star) {
    star.style.background =
      'linear-gradient(90deg, #B8963E 50%, #D9D9D9 50%)';

    star.style.webkitBackgroundClip = 'text';
    star.style.webkitTextFillColor = 'transparent';
    star.style.backgroundClip = 'text';
  });

  // Initialize cart on every page
  fetchCart();

});


/* ═══════════════════
   TOAST
═══════════════════ */

let toastTimeout;

function showToast(message, isError) {
  const toast = document.getElementById('toast');

  if (!toast) return;

  toast.textContent = message;
  toast.style.background = isError ? '#C0392B' : '#1A1714';
  toast.classList.add('is-visible');

  clearTimeout(toastTimeout);

  toastTimeout = setTimeout(() => {
    toast.classList.remove('is-visible');
  }, 3000);
}


/* ═══════════════════
   FILTERS (collection page)
═══════════════════ */

function toggleFilters() {
  const sidebar = document.getElementById('collectionSidebar');
  const layout = document.getElementById('collectionLayout');
  const btn = document.getElementById('filterToggleBtn');

  if (!sidebar) return;

  const isOpen = sidebar.classList.toggle('is-open');

  if (layout) {
    layout.classList.toggle('filters-open', isOpen);
  }

  if (btn) {
    btn.classList.toggle('is-active', isOpen);
    btn.setAttribute('aria-expanded', isOpen.toString());
  }
}


function toggleFilterGroup(btn) {
  btn.classList.toggle('is-open');

  if (btn.nextElementSibling) {
    btn.nextElementSibling.classList.toggle('is-open');
  }

  btn.setAttribute(
    'aria-expanded',
    btn.classList.contains('is-open').toString()
  );
}


function applyFilter() {
  const url = new URL(window.location.href);

  // Clear existing filter parameters
  for (const key of [...url.searchParams.keys()]) {
    if (key.startsWith('filter.')) {
      url.searchParams.delete(key);
    }
  }

  document.querySelectorAll(
    '.filter-checkbox__input:checked'
  ).forEach(input => {
    url.searchParams.append(input.name, input.value);
  });

  window.location.href = url.toString();
}


function applyPriceFilter() {
  const minInput = document.querySelector(
    '.price-range-input[name*="gte"]'
  );

  const maxInput = document.querySelector(
    '.price-range-input[name*="lte"]'
  );

  if (!minInput || !maxInput) return;

  const url = new URL(window.location.href);

  if (minInput.value) {
    url.searchParams.set(
      minInput.name,
      parseFloat(minInput.value) * 100
    );
  } else {
    url.searchParams.delete(minInput.name);
  }

  if (maxInput.value) {
    url.searchParams.set(
      maxInput.name,
      parseFloat(maxInput.value) * 100
    );
  } else {
    url.searchParams.delete(maxInput.name);
  }

  window.location.href = url.toString();
}


function clearFilters() {
  window.location.href = window.location.pathname;
}


function sortCollection(value) {
  const url = new URL(window.location.href);

  url.searchParams.set('sort_by', value);

  window.location.href = url.toString();
}


function setGridView(cols, btn) {
  document.querySelectorAll('.view-toggle__btn').forEach(b => {
    b.classList.remove('is-active');
  });

  if (btn) {
    btn.classList.add('is-active');
  }

  const grid = document.getElementById('productsGrid');

  if (grid) {
    grid.classList.remove(
      'products-grid--2',
      'products-grid--4'
    );

    grid.classList.add('products-grid--' + cols);
  }
}


/* ═══════════════════
   FILTER DRAWER (mobile)
═══════════════════ */

function openFilterDrawer() {
  const drawer = document.getElementById('filterDrawer');
  const overlay = document.getElementById('filterOverlay');

  if (drawer) {
    drawer.style.display = 'block';

    setTimeout(() => {
      drawer.classList.add('is-open');
    }, 20);
  }

  if (overlay) {
    overlay.style.display = 'block';

    setTimeout(() => {
      overlay.classList.add('is-open');
    }, 20);
  }

  document.body.style.overflow = 'hidden';
}


function closeFilterDrawer() {
  const drawer = document.getElementById('filterDrawer');
  const overlay = document.getElementById('filterOverlay');

  if (drawer) {
    drawer.classList.remove('is-open');

    setTimeout(() => {
      drawer.style.display = 'none';
    }, 320);
  }

  if (overlay) {
    overlay.classList.remove('is-open');

    setTimeout(() => {
      overlay.style.display = 'none';
    }, 320);
  }

  document.body.style.overflow = '';
}


/* ═══════════════════
   HOW IT WORKS TABS
═══════════════════ */

function hiwSwitch(btn, id) {
  document.querySelectorAll('.hiw-tab').forEach(tab => {
    tab.classList.remove('hiw-tab--active');
  });

  if (btn) {
    btn.classList.add('hiw-tab--active');
  }

  const prepaid = document.getElementById('hiw-prepaid');
  const partial = document.getElementById('hiw-partial');

  if (id === 'hiw-prepaid') {
    if (prepaid) prepaid.style.display = 'flex';
    if (partial) partial.style.display = 'none';
  } else {
    if (prepaid) prepaid.style.display = 'none';
    if (partial) partial.style.display = 'flex';
  }
}